export default "__VITE_ASSET__CHJDzW0X__"